import React from 'react'
import { Button, Modal, Form, Icon, List } from 'semantic-ui-react'
import { strings } from '../core/strings';

function ReportModal(props) {
    const [open, setOpen] = React.useState(false)

    const onClick = () => {
        props.onSend();
        setOpen(false);
    }

    const list_items = props.reports.map(report => {
        return (
            <List.Item key={report.id_report}>
                <List.Icon name='talk' size='large' verticalAlign='middle' />
                <List.Content>
                    <List.Header as='h4'>{report.report}</List.Header>
                    <List.Description>{report.datetime}</List.Description>
                </List.Content>
            </List.Item>
        )
    })

    return (
        <Modal
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
            open={open}
            trigger={
                <Button color='orange' className={props.reports.length > 0 ? 'blink_me' : ''}>
                    <Icon name='exclamation triangle' /> {props.action_button_content != undefined ? props.action_button_content : strings.edit_text_button}
                </Button>
            }
        >
            <Modal.Header>{strings.send_report_title}</Modal.Header>

            <Modal.Content >
                <List divided relaxed>
                    {list_items}
                </List>

            </Modal.Content>

            <Modal.Content >
                <Form size='huge'>
                    <Form.TextArea
                        label='Segnalazione'
                        onChange={props.onChangeReport}>
                    </Form.TextArea>
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button className='secondary-color-background' onClick={() => setOpen(false)}>
                    {strings.message_action_giveup}
                </Button>
                <Button
                    content="Invia"
                    labelPosition='right'
                    icon='send'
                    onClick={() => onClick()}
                    positive
                />
            </Modal.Actions>
        </Modal>
    )
}

export default ReportModal
